export default __webpack_public_path__ + "static/domea-1-689a34ec742b406278a45cd0c500f61c.jpg";